module.exports = __webpack_public_path__ + "img/c8ce942.jpg";